(function(){
  if(window.__xstrapRecommendedGearLoaded)return;
  window.__xstrapRecommendedGearLoaded=true;
  function update(s){
    if(!s)return;
    var track=s.querySelector('[data-xsrc-track]');
    if(!track)return;
    var maximum=track.scrollWidth-track.clientWidth;
    s.querySelectorAll('[data-xsrc-arrow]').forEach(function(button){
      var direction=Number(button.getAttribute('data-xsrc-arrow'));
      button.disabled=maximum<5||(direction<0?track.scrollLeft<=3:track.scrollLeft>=maximum-3);
    });
  }
  function initialize(scope){
    (scope||document).querySelectorAll('[data-xsrc-section]').forEach(function(s){
      if(s.dataset.xsrcReady==='1')return;
      s.dataset.xsrcReady='1';
      var track=s.querySelector('[data-xsrc-track]');
      if(track){track.addEventListener('scroll',function(){update(s)},{passive:true});update(s)}
    });
  }
  document.addEventListener('click',function(event){
    var b=event.target.closest('[data-xsrc-arrow]');
    if(!b||b.disabled)return;
    var section=b.closest('[data-xsrc-section]'),track=section&&section.querySelector('[data-xsrc-track]');
    if(!track)return;
    var item=track.querySelector('.xsrc__card'),direction=Number(b.getAttribute('data-xsrc-arrow'));
    var gap=parseFloat(window.getComputedStyle(track).columnGap)||16;
    track.scrollBy({left:direction*(item?item.getBoundingClientRect().width+gap:track.clientWidth),behavior:'smooth'});
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initialize(document)});
  else initialize(document);
  document.addEventListener('shopify:section:load',function(e){initialize(e.target)});
  window.addEventListener('resize',function(){document.querySelectorAll('[data-xsrc-section]').forEach(update)});
})();